/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AdmitWorkloadSubjectForm,
  AdmitWorkloadSubjectForm$Outbound,
  AdmitWorkloadSubjectForm$outboundSchema,
} from "../components/admitworkloadsubjectform.js";

export type AdmitWorkloadSubjectSecurityOption1 = {
  sessionHeaderGramSession: string;
};

export type AdmitWorkloadSubjectSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type AdmitWorkloadSubjectSecurity = {
  option1?: AdmitWorkloadSubjectSecurityOption1 | undefined;
  option2?: AdmitWorkloadSubjectSecurityOption2 | undefined;
};

export type AdmitWorkloadSubjectRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  admitWorkloadSubjectForm: AdmitWorkloadSubjectForm;
};

/** @internal */
export type AdmitWorkloadSubjectSecurityOption1$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const AdmitWorkloadSubjectSecurityOption1$outboundSchema: z.ZodMiniType<
  AdmitWorkloadSubjectSecurityOption1$Outbound,
  AdmitWorkloadSubjectSecurityOption1
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function admitWorkloadSubjectSecurityOption1ToJSON(
  admitWorkloadSubjectSecurityOption1: AdmitWorkloadSubjectSecurityOption1,
): string {
  return JSON.stringify(
    AdmitWorkloadSubjectSecurityOption1$outboundSchema.parse(
      admitWorkloadSubjectSecurityOption1,
    ),
  );
}

/** @internal */
export type AdmitWorkloadSubjectSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const AdmitWorkloadSubjectSecurityOption2$outboundSchema: z.ZodMiniType<
  AdmitWorkloadSubjectSecurityOption2$Outbound,
  AdmitWorkloadSubjectSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function admitWorkloadSubjectSecurityOption2ToJSON(
  admitWorkloadSubjectSecurityOption2: AdmitWorkloadSubjectSecurityOption2,
): string {
  return JSON.stringify(
    AdmitWorkloadSubjectSecurityOption2$outboundSchema.parse(
      admitWorkloadSubjectSecurityOption2,
    ),
  );
}

/** @internal */
export type AdmitWorkloadSubjectSecurity$Outbound = {
  Option1?: AdmitWorkloadSubjectSecurityOption1$Outbound | undefined;
  Option2?: AdmitWorkloadSubjectSecurityOption2$Outbound | undefined;
};

/** @internal */
export const AdmitWorkloadSubjectSecurity$outboundSchema: z.ZodMiniType<
  AdmitWorkloadSubjectSecurity$Outbound,
  AdmitWorkloadSubjectSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => AdmitWorkloadSubjectSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => AdmitWorkloadSubjectSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function admitWorkloadSubjectSecurityToJSON(
  admitWorkloadSubjectSecurity: AdmitWorkloadSubjectSecurity,
): string {
  return JSON.stringify(
    AdmitWorkloadSubjectSecurity$outboundSchema.parse(
      admitWorkloadSubjectSecurity,
    ),
  );
}

/** @internal */
export type AdmitWorkloadSubjectRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  AdmitWorkloadSubjectForm: AdmitWorkloadSubjectForm$Outbound;
};

/** @internal */
export const AdmitWorkloadSubjectRequest$outboundSchema: z.ZodMiniType<
  AdmitWorkloadSubjectRequest$Outbound,
  AdmitWorkloadSubjectRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    admitWorkloadSubjectForm: AdmitWorkloadSubjectForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      admitWorkloadSubjectForm: "AdmitWorkloadSubjectForm",
    });
  }),
);

export function admitWorkloadSubjectRequestToJSON(
  admitWorkloadSubjectRequest: AdmitWorkloadSubjectRequest,
): string {
  return JSON.stringify(
    AdmitWorkloadSubjectRequest$outboundSchema.parse(
      admitWorkloadSubjectRequest,
    ),
  );
}
